module.exports = __webpack_public_path__ + "/images/logo-af-ikea.6f5037a.svg";